
import React from 'react';
import { Mountain } from 'lucide-react';
import RotatingText from '@/components/RotatingText';

interface HeroContentProps {
  regionTexts: string[];
}

const HeroContent: React.FC<HeroContentProps> = ({ regionTexts }) => {
  return (
    <div className="flex flex-col items-center text-center space-y-6 max-w-3xl mx-auto">
      <div className="inline-flex flex-wrap justify-center items-center gap-1 bg-card/90 dark:bg-card/80 text-card-foreground rounded-full py-2 px-4 text-sm font-medium animate-fade-in shadow-sm border border-border/20">
        <Mountain className="h-4 w-4 flex-shrink-0 text-primary" />
        <span className="whitespace-nowrap">Discover the best</span>
        <RotatingText 
          texts={regionTexts} 
          className="font-bold text-primary dark:text-accent" 
          wrapperClassName="mx-1"
        />
        <span className="whitespace-nowrap">treks</span>
      </div>
      
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight animate-fade-up">
        Find your<span className="text-primary dark:text-accent"> next</span> adventure
      </h1>
      
      <p className="text-base md:text-lg text-muted-foreground max-w-2xl animate-fade-up">
        Find and compare the best trek packages from top adventure companies, all in one place.
      </p>
    </div>
  );
};

export default HeroContent;
